var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeCloseOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4854",
    "data-name": "Rectangle 4854",
    width: 15.492,
    height: 11.336,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13283",
    "data-name": "Group 13283",
    transform: "translate(-1421 -325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(1421 325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.875,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13219",
    "data-name": "Group 13219",
    transform: "translate(1425.344 331.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12189",
    "data-name": "Group 12189",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45243",
    "data-name": "Path 45243",
    d: "M3.642,9.062c-.4-.277-.766-.524-1.123-.789A13.825,13.825,0,0,1,.153,6.027a.5.5,0,0,1-.008-.714A13.047,13.047,0,0,1,4.717,1.722a7.056,7.056,0,0,1,3.168-.687,7.261,7.261,0,0,1,2.878.687.191.191,0,0,0,.26-.048c.5-.505,1-1,1.5-1.5a.5.5,0,0,1,.53-.144.488.488,0,0,1,.355.381.535.535,0,0,1-.183.52Q12.2,1.941,11.185,2.962,7.1,7.036,3.016,11.107a.841.841,0,0,1-.363.216.478.478,0,0,1-.534-.27.5.5,0,0,1,.107-.605q.63-.635,1.266-1.263c.042-.041.092-.075.15-.122M5.593,7.034,9.117,3.518A2.542,2.542,0,0,0,5.593,7.034",
    transform: "translate(-0.001 0)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45244",
    "data-name": "Path 45244",
    d: "M131.478,73.914c.036-.041.061-.074.09-.1.52-.52,1.04-1.041,1.564-1.557a.247.247,0,0,1,.176-.074,2.551,2.551,0,0,0,2.663-1.615,2.316,2.316,0,0,0,.158-1.2.207.207,0,0,1,.05-.154q1.147-1.154,2.3-2.3c.023-.023.046-.044.081-.077.1.076.208.148.309.226a14.408,14.408,0,0,1,2.3,2.205.5.5,0,0,1,.024.689,12.739,12.739,0,0,1-4.978,3.778,6.733,6.733,0,0,1-4.667.208c-.019-.006-.037-.014-.068-.027",
    transform: "translate(-125.825 -63.962)",
    fill: "#ef7b13"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseOrange);
export default __webpack_public_path__ + "static/media/eye-close-orange.806e1dee3921787e6c9780c19a56a26c.svg";
export { ForwardRef as ReactComponent };